/**
 * Actions for wizard-time schema profiling (PRE-2716).
 *
 * Two request shapes, one proposal:
 *   - sampleConnection: bounded query via system-connection-service (PRE-2717)
 *   - getSchemaProfile:  profile a file or an already-materialised sample
 *
 * Suggestion accept/reject state lives here rather than in component state so
 * that navigating back and forth in the wizard does not silently discard the
 * user's decisions.
 */

export const GET_SCHEMA_PROFILE_REQUEST = "GET_SCHEMA_PROFILE_REQUEST";
export const GET_SCHEMA_PROFILE_SUCCESS = "GET_SCHEMA_PROFILE_SUCCESS";
export const GET_SCHEMA_PROFILE_FAILURE = "GET_SCHEMA_PROFILE_FAILURE";
export const GET_SCHEMA_PROFILE_UNSUPPORTED = "GET_SCHEMA_PROFILE_UNSUPPORTED";

export const SAMPLE_CONNECTION_REQUEST = "SAMPLE_CONNECTION_REQUEST";

export const SET_SUGGESTION_STATUS = "SET_SUGGESTION_STATUS";
export const SET_ALL_SUGGESTION_STATUSES = "SET_ALL_SUGGESTION_STATUSES";
export const RESET_SCHEMA_PROFILE = "RESET_SCHEMA_PROFILE";

export const SUGGESTION_STATUS = {
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
};

/** Profile a file source (PRE-2718). */
export const getSchemaProfileRequest = ({ dataFile, firstRowLabel, schemaDetectOption, delimiter, fixWidthColumnDetectOption, fixWidthColumnSpecs, sampleSize, options }) => ({
    type: GET_SCHEMA_PROFILE_REQUEST,
    params: {
        profileConfig: {
            dataFile,
            firstRowLabel,
            schemaDetectOption,
            delimiter,
            fixWidthColumnDetectOption,
            fixWidthColumnSpecs,
            sampleSize,
            options,
        },
    },
});

/**
 * Sample a data connection and then profile the rows (PRE-2717).
 * The saga chains the two calls so the caller sees one request.
 */
export const sampleConnectionRequest = ({ connectionId, connectionType, objectName, fields, sampleSize, options }) => ({
    type: SAMPLE_CONNECTION_REQUEST,
    params: {
        connectionId,
        connectionType,
        objectName,
        fields,
        sampleSize,
        options,
    },
});

export const getSchemaProfileSuccess = (schemaProfile) => ({
    type: GET_SCHEMA_PROFILE_SUCCESS,
    payload: { schemaProfile },
});

export const getSchemaProfileFailure = (error) => ({
    type: GET_SCHEMA_PROFILE_FAILURE,
    payload: { error },
});

/**
 * Not a failure: the source cannot be sampled (DDL, S3, unsupported connector,
 * timeout). The wizard continues unassisted.
 */
export const getSchemaProfileUnsupported = ({ reason, message }) => ({
    type: GET_SCHEMA_PROFILE_UNSUPPORTED,
    payload: { reason, message },
});

export const setSuggestionStatus = (suggestionId, status) => ({
    type: SET_SUGGESTION_STATUS,
    payload: { suggestionId, status },
});

/** Bulk accept/reject. A convenience only; never the default state. */
export const setAllSuggestionStatuses = (status, fieldName = null) => ({
    type: SET_ALL_SUGGESTION_STATUSES,
    payload: { status, fieldName },
});

export const resetSchemaProfile = () => ({
    type: RESET_SCHEMA_PROFILE,
});
